import {Component, inject, Input, input} from '@angular/core';
import { CoreModule } from "../../_core/core.module";
import { AppService } from "../../app.service";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatMenu, MatMenuItem} from "@angular/material/menu";
import {floor, size} from "lodash";
import {TranslateChatPipe} from "../../chat-bot/chat.service";

@Component({
  selector: 'translation-picker',
	imports: [
		CoreModule,
		MatIcon,
		MatIconButton,
		MatMenu,
		MatMenuItem,
		TranslateChatPipe
	],
  templateUrl: './inline-translation-picker.component.html',
  styleUrl: './inline-translation-picker.component.scss',
})
export class InlineTranslationPickerComponent {
	@Input() options: any;
	public appService = inject(AppService);



}
